module.exports = __webpack_public_path__ + "img/sprinkle-29.ffdfafdc.webp";